<template>
  <div>
    <div class="home-page">
      <div class="bg"></div>
      <div class="content">
        <div class="flex">
          <div class="icon">
            <img src="./../../assets/home/icon.png" alt="" />
          </div>
          <div>
            您将观看一段主诉视频，并通过视诊、鉴别诊断、临床检查、最终诊断、确认疗法多个环节模拟实际诊疗过程接诊1例病例。
          </div>
        </div>
        <div class="flex">
          <div class="icon">
            <img src="./../../assets/home/icon.png" alt="" />
          </div>
          <div>各个环节设置相应题目，具体分值如下：</div>
        </div>
        <div class="item">
          <div class="left">视诊题</div>
          <div class="right">30分</div>
        </div>
        <div class="item">
          <div class="left">鉴别诊断题</div>
          <div class="right">10分</div>
        </div>
        <div class="item">
          <div class="left">临床检查题</div>
          <div class="right">30分</div>
        </div>
        <div class="item">
          <div class="left">最终判断题</div>
          <div class="right">20分</div>
        </div>
        <div class="item itemLast">
          <div class="left">确认疗法题</div>
          <div class="right">10分</div>
        </div>
        <div class="flex">
          <div class="icon">
            <img src="./../../assets/home/icon.png" alt="" />
          </div>
          <div>
            题目均为选择题，有单选、多选、不定项选择等多个形式，请留意具体题目说明。
          </div>
        </div>
        <div @click="handleGoBack" class="btn">返 回</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  methods: {
    handleGoBack() {
      this.$router.back();
    },
  },
};
</script>

<style lang="less" scoped>
.home-page {
  width: 100%;
  min-height: 100vh;
  background-image: url("./../../assets/home/cbbj.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .bg {
    height: 90px;
  }
  .content {
    width: 653px;
    height: 1122px;
    background: rgba(255, 255, 255, 0.85);
    box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
    border: 2px solid #ffffff;
    border-radius: 60px;
    margin: 0 auto;
    padding-top: 120px;
    .flex {
      display: flex;
      padding: 0 60px 50px 60px;
      .icon {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        margin-right: 24px;
        img {
          width: 16px;
          height: 16px;
        }
      }
      font-size: 25px;
      font-family: HarmonyOS Sans SC;
      font-weight: 500;
      color: #4c4c4c;
      line-height: 50px;
    }
    .flex:nth-child(2) {
      padding-bottom: 0;
    }
    .item {
      display: flex;
      margin-left: 100px;
      font-size: 25px;
      font-family: HarmonyOS Sans SC;
      font-weight: 500;
      color: #4c4c4c;
      line-height: 50px;
      .left {
        width: 164px;
      }
    }
    .itemLast {
      margin-bottom: 50px;
    }
    .btn {
      width: 303px;
      height: 69px;
      background: linear-gradient(
        132.74deg,
        rgba(0, 187, 177, 1) 0%,
        rgba(0, 86, 140, 1) 74.31%,
        rgba(171, 59, 127, 1) 100%
      );
      border: 1px solid #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
      border-radius: 34px;
      margin: 0 auto;
      text-align: center;
      line-height: 69px;
      font-size: 36px;
      font-family: HarmonyOS Sans SC;
      font-weight: 500;
      color: #ffffff;
      margin-top: 200px;
    }
  }
}
</style>
